import React from "react";
import ServicesHero from "../components/services/ServicesHero";
import ServicesGrid from "../components/services/ServicesGrid";
import PricingPlans from "../components/services/PricingPlans";
import Accordion from "../components/shared/Accordion";
import { servicesFaq } from "../servicesData";

export default function Services() {
  return (
    <>
      <ServicesHero />
      <ServicesGrid />
      <PricingPlans />
      <section className="mu-section">
        <div className="container">
          <div className="mb-4">
            <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>Questions</div>
            <h2 className="section-title">Frequently Asked Questions</h2>
          </div>
          <Accordion items={servicesFaq} />
        </div>
      </section>
    </>
  );
}
